export default __webpack_public_path__ + "static/media/arrow-down-red.ba22cfd5.svg";